(function () {
  function initQuantityLimits() {
    var qtyInput = document.querySelector('.quantity__input');
    if (!qtyInput) return;

    var minQty = parseInt(qtyInput.getAttribute('min') || '1', 10);
    var maxQty = qtyInput.getAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : null;

    if (parseInt(qtyInput.value, 10) < minQty) qtyInput.value = minQty;

    var minusBtn = document.querySelector('.quantity__button[name="minus"]');
    var plusBtn  = document.querySelector('.quantity__button[name="plus"]');

    function updateButtons() {
      var current = parseInt(qtyInput.value, 10);
      if (minusBtn) minusBtn.disabled = current <= minQty;
      if (plusBtn && maxQty) plusBtn.disabled = current >= maxQty;
    }

    updateButtons();
    qtyInput.addEventListener('change', updateButtons);
    qtyInput.addEventListener('input',  updateButtons);

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    function validate(e) {
      var qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < minQty) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError('La cantidad mínima para este producto es ' + minQty + ' unidades.');
        qtyInput.value = minQty;
        updateButtons();
        return false;
      }
      if (maxQty && qty > maxQty) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError('La cantidad máxima para este producto es ' + maxQty + ' unidades.');
        qtyInput.value = maxQty;
        updateButtons();
        return false;
      }
      removeError();
    }

    form.addEventListener('submit', validate);
    var addBtn = form.querySelector('[name="add"]');
    if (addBtn) addBtn.addEventListener('click', validate, true);
  }

  function showError(msg) {
    removeError();
    var err = document.createElement('p');
    err.id = 'efisa-qty-error';
    err.style.cssText = 'color:#c00;font-weight:bold;margin-top:8px;font-size:14px;';
    err.textContent = msg;
    var container = document.querySelector('.product-form__quantity');
    if (container) container.appendChild(err);
  }

  function removeError() {
    var old = document.getElementById('efisa-qty-error');
    if (old) old.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityLimits);
  } else {
    initQuantityLimits();
  }
})();